export default `<form class="views-exposed-form" data-drupal-selector="views-exposed-form-resources-block-1" action="/page-all-filters-demo-purposes" method="get" id="views-exposed-form-resources-block-1" accept-charset="UTF-8">
  <div class="form--inline clearfix">
    <div class="js-form-item form-item js-form-type-textfield form-type-textfield js-form-item-query form-item-query">
      <label for="edit-query--3">Search</label>
        <div class="js-form-item-query input-wrapper">
          <input data-drupal-selector="edit-query" type="text" placeholder="- Search by Keyword -" id="edit-query--3" name="query" value="" size="30" maxlength="128" class="form-text" />
          <input data-drupal-selector="edit-submit-query" aria-label="submit query" type="submit" id="edit-submit-query" value=''/>
        </div>
    </div>
    <div class="js-form-item form-item js-form-type-select form-type-select js-form-item-category form-item-category">
      <label for="edit-category">Category</label>
      <select data-drupal-selector="edit-category" id="edit-category" name="category" class="form-select">
        <option value="All" selected="selected">- Select a Category -</option>
        <option value="All" >Cat 1</option>
        <option value="All" >Cat 2</option>
        <option value="All" >Cat 3</option>
        <option value="All" >Cat 4</option>
        <option value="All" >Cat 5</option>
      </select>
    </div>
    <div class="js-form-item form-item js-form-type-select form-type-select js-form-item-department form-item-department">
      <label for="edit-department--2">Department</label>
      <select data-drupal-selector="edit-department" id="edit-department--2" name="department" class="form-select">
        <option value="All" selected="selected">- Select a Department -</option>
        <option value="1">Dept 1</option>
        <option value="2">Dept 2</option>
        <option value="3">Dept 3</option>
        <option value="4">Dept 4</option>
      </select>
    </div>
    <div class="js-form-item form-item js-form-type-select form-type-select js-form-item-audience form-item-audience">
      <label for="edit-audience">Audience</label>
      <select data-drupal-selector="edit-audience" id="edit-audience" name="audience" class="form-select">
        <option value="All" selected="selected">- Select an Audience -</option>
        <option value="1">Group 1</option>
        <option value="2">Group 2</option>
        <option value="3">Group 3</option>
        <option value="4">Group 4</option>
      </select>
    </div>
    <div data-drupal-selector="edit-actions" class="form-actions js-form-wrapper form-wrapper" id="edit-actions--4">
      <input data-drupal-selector="edit-submit-resources" type="submit" id="edit-submit-resources" value="Search" class="button js-form-submit form-submit" />
      <input data-drupal-selector="edit-reset" type="submit" id="edit-reset--4" name="op" value="X Clear" class="button js-form-submit form-submit">
    </div>
  </div>
</form>
`;
